import { useBusinessWorkflowStore } from '@/stores/businessWorkflowStore'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { type BusinessWorkflowLoadOptions, loadBusinessWorkflowFromDataClient } from './customers'

export function useBusinessWorkflowDataClientHydration(
  enabled = true,
  options: BusinessWorkflowLoadOptions = {},
) {
  const hydrateWorkflow = useBusinessWorkflowStore((state) => state.hydrateWorkflow)
  const query = useQuery({
    queryKey: ['business-workflow-data-client', options],
    queryFn: () => loadBusinessWorkflowFromDataClient(options, useBusinessWorkflowStore.getState()),
    enabled,
    staleTime: 30_000,
  })

  useEffect(() => {
    if (query.data) hydrateWorkflow(query.data)
  }, [hydrateWorkflow, query.data])

  return query
}
